<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.userId"
        placeholder="用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.contractStatus"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in statusArr"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="用户ID"
        align="center"
        prop="userId"
      ></el-table-column>
      <el-table-column
        label="合同名称"
        align="center"
        prop="contractName"
        width="200px"
      ></el-table-column>
      <el-table-column label="状态" align="center" prop="state" width="300px">
        <template slot-scope="scope">
          {{
            statusArr.find((item) => item.key === scope.row.contractStatus)
              ?.value || "未知状态"
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getSignContractList } from "@/api/signature.js";
import { formatApiDate } from "@/utils/utils";
import { getValue } from "@/utils/enumUtile";
import { listData, statusArr } from "./data.js";
export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      statusArr: statusArr,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        userId: null,
        contractStatus: null,
      },
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      // this.list = listData.entitys;
      // console.log('搜索条件', this.listQuery);
      // this.total = listData.totalCount;
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
      };
      getSignContractList(params)
        .then((response) => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
